import { Modal } from 'antd';

import styled from 'styled-components';

export const ModalContainer = styled(Modal)<{ isConfirm?: boolean }>`
  .ant-modal-body {
    ${({ isConfirm }) => (isConfirm ? '' : 'height: 674px')};
    overflow-y: auto;
    padding: 20px 0;
  }

  .ant-table {
    height: 504px;
  }

  .ant-table-tbody {
    width: 850px;
  }
`;

export const Container = styled.div`
  p {
    font-size: 14px;
    font-weight: 500;
    color: #202020;
  }
`;

export const Link = styled.a`
  color: black;
  :hover {
    color: black;
  }
`;

export const Disable = styled.div`
  color: #878787;
  cursor: auto;
`;

export const ApplyMemberName = styled.div`
  display: flex;
  align-items: center;
`;
